module.exports = __webpack_public_path__ + "static/detail_bg.5af75bb6.png";